// extracted by mini-css-extract-plugin
export default {"leg":"RoundTrip_leg__NUAha","firstLeg":"RoundTrip_firstLeg__bKZAc","secondLeg":"RoundTrip_secondLeg__FnyVM","overlay":"RoundTrip_overlay__9gL47","icon":"RoundTrip_icon__brWZp"};